import { SVGProps } from '@components/Icon/types';

export const MoreInfo = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2, 2)">
      <path
        d="M10.1406 13.3145C10.4598 13.3796 10.7002 13.6616 10.7002 14C10.7002 14.3384 10.4598 14.6204 10.1406 14.6855L10 14.7002H4C3.6134 14.7002 3.2998 14.3866 3.2998 14C3.2998 13.6134 3.6134 13.2998 4 13.2998H10L10.1406 13.3145Z"
        fill={fill}
      />
      <path
        d="M16.1406 9.31445C16.4598 9.37958 16.7002 9.66159 16.7002 10C16.7002 10.3384 16.4598 10.6204 16.1406 10.6855L16 10.7002H4C3.6134 10.7002 3.2998 10.3866 3.2998 10C3.2998 9.6134 3.6134 9.2998 4 9.2998H16L16.1406 9.31445Z"
        fill={fill}
      />
      <path
        d="M16.1406 5.31445C16.4598 5.37958 16.7002 5.66159 16.7002 6C16.7002 6.33841 16.4598 6.62042 16.1406 6.68555L16 6.7002H4C3.6134 6.7002 3.2998 6.3866 3.2998 6C3.2998 5.6134 3.6134 5.2998 4 5.2998H16L16.1406 5.31445Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0C18.14 0 19.8879 1.68056 19.9951 3.79395L20 4V16L19.9951 16.2061C19.8913 18.2512 18.2512 19.8913 16.2061 19.9951L16 20H4C1.79086 20 3.22128e-08 18.2091 0 16V4C0 1.79086 1.79086 3.22133e-08 4 0H16ZM4 1.40039C2.56406 1.40039 1.40039 2.56406 1.40039 4V16C1.40039 17.4359 2.56406 18.5996 4 18.5996H16C17.4359 18.5996 18.5996 17.4359 18.5996 16V4C18.5996 2.56406 17.4359 1.40039 16 1.40039H4Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'more-info';
